// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Home20 from './Home20.tsx';
import Home24 from './Home24.tsx';

type HomeProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Home20,
    Home24,
};

const Home: FC<HomeProps> = ({ variation, ...props }) => {
    const variationKey = `Home${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Home" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Home;
